import axios from "axios";

import { API_BASE_URL } from "../constants";

export default class ComplianceFrameworkSettingsService {
    static instance;
    resource = `${API_BASE_URL}/framework_settings`;

    constructor() { }

    static getInstance() {
        if (!ComplianceFrameworkSettingsService.instance) {
            ComplianceFrameworkSettingsService.instance = new ComplianceFrameworkSettingsService();
        }

        return ComplianceFrameworkSettingsService.instance;
    }

    async fetchSettings() {
        const response = await axios.get(`${this.resource}/show`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data;
    }

    async activateFramework(payload) {
        const response = await axios.post(`${this.resource}/activate`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        
        return response.data;
    }

    async deactivateFramework(payload) {
        const response = await axios.post(`${this.resource}/deactivate`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        
        return response.data;
    }

    async addLegalToFramework(payload) {
        const response = await axios.post(`${this.resource}/add_legal_entities`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        
        return response.data;
    }

    async removeLegalFromFramework(payload) {
        const response = await axios.post(`${this.resource}/remove_legal_entities`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        
        return response.data;
    }

    async fetchAccessibleControls(params = {}) {
        const response = await axios.get(`${this.resource}/accessible_controls`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data;
    }
}
